import request from '@/utils/request'

const giftApiList = [
  // 获取待办
  ['getUpComingList', 'GET', '/api/hulk/?router=/home/apply/api/home/leader-deal-list', 'params'],
  // 获取详情
  ['getDetail', 'GET', '/api/hulk/?router=/home/apply/api/home/get-detail', 'params'],
  // 同意
  ['handleDoPass', 'GET', '/api/hulk/?router=/home/apply/api/home/pass', 'params'],
  // 驳回
  ['handleDoDeny', 'GET', '/api/hulk/?router=/home/apply/api/home/deny', 'params'],

]

let apiListMap = giftApiList.reduce((sum, prev) => {
  if (!prev || !prev[0] || !prev[1]) return sum
  sum[prev[0]] = prev
  return sum
}, {})

export function fetchData (apiName, payload) {
  const api = apiListMap[apiName]
  let options
  if (api[4] === 'replace' && payload) {
    options = {
      url: api[2].replace('{id}', payload),
      method: api[1]
    }
  } else {
    options = {
      url: api[2],
      method: api[1]
    }
  }
  if (api[1] === 'GET' && api[4] !== 'replace' && payload) {
    options.params = payload
  }
  if (api[1] === 'POST' && payload) {
    if (api[3] !== 'params') {
      options.data = payload
    } else {
      options.params = payload
    }
  }
  return request(options)
}
